import { render, staticRenderFns } from "./PhotoLoader.vue?vue&type=template&id=6d177048&scoped=true&"
import script from "./PhotoLoader.vue?vue&type=script&lang=js&"
export * from "./PhotoLoader.vue?vue&type=script&lang=js&"
import style0 from "./PhotoLoader.vue?vue&type=style&index=0&id=6d177048&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d177048",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
